import React from 'react'

import Navi from 'components/Navi'
import Footer from 'components/Footer'
import { siteMetadata } from '../../../gatsby-config'

import 'bootstrap/scss/bootstrap.scss'
import 'animate.css/animate.css'
import 'font-awesome/css/font-awesome.css'
import '../../styles/isotop.css'
import '../../styles/style.css'
import '../../styles/responsive.css'
import '../../styles/xsIcon.css'
import '../../styles/magnific-popup.css'

import jQuery from 'jquery'
if (typeof window !== 'undefined') {
  window.jQuery = jQuery
}

import 'bootstrap'
import './isotope.pkgd.min'
import './jquery.jCounter'
import './smoothscroll'

class Layout extends React.Component {
  componentDidMount() {
    require('./jquery.magnific-popup')
    require('./main')
  }

  render() {
    const { children } = this.props
    return (
      <div>
        <Navi title={siteMetadata.title} {...this.props} />
        {children}
        <Footer title={siteMetadata.title} author={siteMetadata.author} />
      </div>
    )
  }
}

export default Layout
